"use strict";

const { schedulePathForYear } = require("./scheduleArchive");

const SCHEDULE_ITEM_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const SCHEDULE_EVENT_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

const requireNonEmptyString = (value, label) => {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error(`Missing or invalid ${label}.`);
  }

  return value.trim();
};

const createScheduleEventCatalogEntry = ({
  scheduleItemId,
  year,
  slug,
  name,
  pageTitle,
  description,
}) => {
  if (!SCHEDULE_ITEM_ID_PATTERN.test(scheduleItemId)) {
    throw new Error(`Invalid schedule item id: ${scheduleItemId}`);
  }
  if (!SCHEDULE_EVENT_SLUG_PATTERN.test(slug)) {
    throw new Error(`Invalid schedule event slug: ${slug}`);
  }

  const normalizedName = requireNonEmptyString(name, "schedule event name");
  const normalizedPageTitle = requireNonEmptyString(
    pageTitle,
    `page title for ${scheduleItemId}`
  );
  const normalizedDescription = requireNonEmptyString(
    description,
    `page description for ${scheduleItemId}`
  );
  const schedulePath = schedulePathForYear(year);

  return Object.freeze({
    scheduleItemId,
    year,
    slug,
    path: `${schedulePath}/${slug}`,
    name: normalizedName,
    pageTitle: normalizedPageTitle,
    description: normalizedDescription,
  });
};

const scheduleEventCatalog = Object.freeze([
  createScheduleEventCatalogEntry({
    scheduleItemId: "schedule-magic-flute-highlight-2026",
    year: 2026,
    slug: "michiko-hayashi-magic-flute",
    name: "室内楽ホールdeオペラ 林美智子の『魔笛』！",
    pageTitle: "林美智子の『魔笛』！｜本多信明 タミーノ役出演",
    description:
      "2026年9月19日・21日、第一生命ホール「室内楽ホールdeオペラ 林美智子の『魔笛』！」にテノール本多信明がタミーノ役で出演します。日時、会場、出演者、料金、チケット情報をご案内します。",
  }),
]);

const scheduleItemIds = scheduleEventCatalog.map(
  ({ scheduleItemId }) => scheduleItemId
);
const scheduleEventPaths = scheduleEventCatalog.map(({ path }) => path);

if (
  new Set(scheduleItemIds).size !== scheduleItemIds.length ||
  new Set(scheduleEventPaths).size !== scheduleEventPaths.length
) {
  throw new Error("Schedule event item ids and paths must be unique.");
}

const scheduleEventCatalogEntryForItemId = (scheduleItemId) =>
  scheduleEventCatalog.find(
    (entry) => entry.scheduleItemId === scheduleItemId
  ) || null;

const scheduleEventCatalogEntryForPath = (routePath) =>
  scheduleEventCatalog.find((entry) => entry.path === routePath) || null;

module.exports = Object.freeze({
  scheduleEventCatalog,
  scheduleEventCatalogEntryForItemId,
  scheduleEventCatalogEntryForPath,
});
